/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calories': {
    width: 16,
    height: 16,
    viewBox: '0 0 50.72 67.04',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M47.41 53.37a25.65 25.65 0 0 1-5.19 6.26A23.65 23.65 0 0 1 36 63.48l-4 1.75 2-3.86c1.79-3.43 1.18-7.63-1.75-12.27a19.88 19.88 0 0 1-2.56 3.16l-2.29 2.22-.25-3.22a20.09 20.09 0 0 0-2.82-8.5 11.82 11.82 0 0 1-3.89 6.44c-2.13 1.73-6.73 6.42-3.34 12.49l.22.34 2.38 4-4.28-1.76A23.84 23.84 0 0 1 3.68 53.35C-5.48 37 7.64 24.46 11.87 21c7.51-6.11 7.35-16.81 7.35-16.91L19.15 1l2.51 1.82c8 5.8 10.75 16.92 11.69 22.51a61 61 0 0 0 5-7.47l1.15-2.06 1.5 1.89c2.62 3.5 8.23 12 9.27 21.38" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/calories.js